import React, { Fragment, useState, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import LaunchIcon from '@material-ui/icons/Launch';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faClockFour } from "@fortawesome/free-solid-svg-icons";


const MCADAailableTimesListActions = ({ data, handlerConfirmedCitas, validateAgendaConfirmedSome, updating }) => {

    const iconColor = '#9b9b9b';


    const handleClick = () => {
        if (!validateAgendaConfirmedSome(data.data.original.id_jornada, data.data.original.id_agenda)) {
            handlerConfirmedCitas(data.data.original);
        }
    };

    return (<Fragment>
        <Tooltip title={updating == false ? "Agendar Cita" : "Reagendar Cita"}>
            <div 
                style={{marginTop: '5px'}}
                onClick={handleClick}>
                <FontAwesomeIcon icon={faClock} size="2x" style={{color: iconColor}} />
            </div>
        </Tooltip>
    </Fragment>)
}

export default MCADAailableTimesListActions;